import React from 'react'

import { oneOfType, string, array } from 'prop-types'

import Aircraft from '../Icons/Aircraft'
import Animals from '../Icons/Animals'
import Animated from '../Icons/Animated'
import AppsAndScripts from '../Icons/AppsAndScripts'
import Architectural from '../Icons/Architectural'
import Art from '../Icons/Art'
import Beginners from '../Icons/Beginners'
import Blender from '../Icons/Blender'
import Cars from '../Icons/Cars'
import CgTextures from '../Icons/CgTextures'
import Characters from '../Icons/Characters'
import Collection from '../Icons/Collection'
import Exterior from '../Icons/Exterior'
import Fashion from '../Icons/Fashion'
import Fbx from '../Icons/Fbx'
import Food from '../Icons/Food'
import FreeItem from '../Icons/FreeItem'
import Furniture from '../Icons/Furniture'
import Gadgets from '../Icons/Gadgets'
import Games from '../Icons/Games'
import Gltf from '../Icons/Gltf'
import Hobby from '../Icons/Hobby'
import Holidays from '../Icons/Holidays'
import Home from '../Icons/Home'
import Household from '../Icons/Household'
import Industrial from '../Icons/Industrial'
import Interior from '../Icons/Interior'
import Jewelry from '../Icons/Jewelry'
import LowPoly from '../Icons/LowPoly'
import Maya from '../Icons/Maya'
import Military from '../Icons/Military'
import Miniatures from '../Icons/Miniatures'
import Obj from '../Icons/Obj'
import OnSale from '../Icons/OnSale'
import Subscription from '../Icons/Subscription'
import PbrModels from '../Icons/PbrModels'
import PbrTextures from '../Icons/PbrTextures'
import Plants from '../Icons/Plants'
import PriceBetween from '../Icons/PriceBetween'
import PriceRange from '../Icons/PriceRange'
import Prints from '../Icons/Prints'
import Rigged from '../Icons/Rigged'
import Scanned from '../Icons/Scanned'
import Science from '../Icons/Science'
import Space from '../Icons/Space'
import Stl from '../Icons/Stl'
import ThreeDsMax from '../Icons/ThreeDsMax'
import Tools from '../Icons/Tools'
import Unity from '../Icons/Unity'
import Unreal from '../Icons/Unreal'
import UpTo from '../Icons/UpTo'
import Various from '../Icons/Various'
import Vehicles from '../Icons/Vehicles'
import Vr from '../Icons/Vr'
import Watercraft from '../Icons/Watercraft'

const svgIconMap = {
  'aircraft': Aircraft,
  'animal': Animals,
  'animals': Animals,
  'architectural': Architectural,
  'car': Cars,
  'character': Characters,
  'exterior': Exterior,
  'interior': Interior,
  'food': Food,
  'furniture': Furniture,
  'household': Household,
  'industrial': Industrial,
  'military': Military,
  'plant': Plants,
  'space': Space,
  'vehicle': Vehicles,

  // By Type

  'low_poly': LowPoly,
  'animated': Animated,
  'rigged': Rigged,
  'pbr': PbrModels,
  'pbr-textures': PbrTextures,
  'scripts-plugins': AppsAndScripts,
  'scanned': Scanned,
  'textures': CgTextures,

  'polygon': LowPoly,
  'printable': Prints,
  'watercraft': Watercraft,
  'low_budget': PriceRange,
  'mid_budget': PriceBetween,
  'high_budget': UpTo,
  'free_item': FreeItem,
  'on_sale': OnSale,
  'subscription': Subscription,
  'collection': Collection,
  'vr': Vr,

  // 3D Formats
  'blender': Blender,
  'obj': Obj,
  'stereolithography': Stl,
  'autodesk-fbx': Fbx,
  'autodesk-3ds-max': ThreeDsMax,
  'autodesk-maya': Maya,
  'gltf': Gltf,
  'unrealengine': Unreal,
  'unity-3d': Unity,

  // Printable
  'art': Art,
  'fashion': Fashion,
  'gadgets': Gadgets,
  'games': Games,
  'games-toys': Games,
  'hobby': Hobby,
  'hobby-diy': Hobby,
  'home': Home,
  'house': Home,
  'jewelry': Jewelry,
  'miniatures': Miniatures,
  'science': Science,
  'tools': Tools,
  'tools-organizers': Tools,
  'holidays': Holidays,
  'various': Various,
  'beginners': Beginners,
}

function ModelIcon({ icon, ...props }) {
  const IconComponent = svgIconMap[icon]

  if (!IconComponent) {
    return null
  }

  return <IconComponent {...props} />
}

ModelIcon.propTypes = {
  icon: oneOfType([string, array]).isRequired,
}

export default ModelIcon
